<div pias-layout-content>
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }
    <br>
    <div class="content">
        <div class="dsu-assessment-container container-fluid" [formGroup]="dsumanagerassessmentForm">
            @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
            <h6 class="page-header">DSU Manager ASSESSMENT FORM FOR NEW INTRODUCER ({{role}})</h6>
            }@else {
            <h6 class="page-header">DSU Manager ASSESSMENT FORM FOR NEW Representative</h6>
            }
            @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
            <h6 class="page-header">Information on New Introducer ({{role}})</h6>
            }@else {
            <h6 class="page-header">Information on New Representative</h6>
            }
            <div class="row">
                <!-- Branch Name -->
                <div class="col-md-6">
                    @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                    <label class="field-label">Name of New Introducer {{role}} (as in NRIC/Passport)</label>
                    }@else {
                    <label class="field-label">Name of New Representative (as in NRIC/Passport)</label>
                    }

                    <mat-form-field class="w-100">
                        <input matInput formControlName="name" placeholder="Enter Name" readonly />
                    </mat-form-field>
                </div>
                <!-- Financial Services Director -->
                <div class="col-md-6">
                    <label class="field-label">
                        <!-- <mat-icon class="label-icon">star</mat-icon> -->
                        Recruiting Manager
                    </label>

                    <mat-form-field class="w-100">
                        <input matInput formControlName="manager" placeholder="Enter Recruiting Manager" readonly />
                    </mat-form-field>
                </div>

                <div class="col-md-6">
                    @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                    <label class="field-label">PIAS Introducer code</label>
                    }@else {
                    <label class="field-label">PIAS Repcode</label>
                    }

                    <mat-form-field class="w-100">
                        <input matInput formControlName="piasrepcode" placeholder="Enter PIAS REP code" />
                        @if(this.dsumanagerassessmentForm.controls["piasrepcode"].invalid
                        && (this.dsumanagerassessmentForm.controls["piasrepcode"].touched ||
                        this.dsumanagerassessmentForm.controls["piasrepcode"].dirty)
                        ) {
                        <mat-error>
                            @if(this.dsumanagerassessmentForm.controls["piasrepcode"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                @if(!['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                <div class="col-md-6">
                    <label class="field-label">
                        <!-- <mat-icon class="label-icon">star</mat-icon> -->
                        UIN (RNF number)
                    </label>

                    <mat-form-field class="w-100">
                        <input matInput formControlName="rnfnumber" placeholder="Enter UIN (RNF number)" />
                        @if(this.dsumanagerassessmentForm.controls["rnfnumber"].invalid
                        && (this.dsumanagerassessmentForm.controls["rnfnumber"].touched ||
                        this.dsumanagerassessmentForm.controls["rnfnumber"].dirty)
                        ) {
                        <mat-error>
                            @if(this.dsumanagerassessmentForm.controls["rnfnumber"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">RNF Approval Date</mat-label>
                    <mat-form-field class="w-100">
                        <input matInput [matDatepicker]="picker" formControlName="rnfApprovalDate"
                            placeholder="Enter RNF Approval Date">
                        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if(this.dsumanagerassessmentForm.controls["rnfApprovalDate"].invalid
                        && (this.dsumanagerassessmentForm.controls["rnfApprovalDate"].touched ||
                        this.dsumanagerassessmentForm.controls["rnfApprovalDate"].dirty)
                        ) {
                        <mat-error>
                            @if(this.dsumanagerassessmentForm.controls["rnfApprovalDate"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Lodgment date</mat-label>
                    <mat-form-field class="w-100">
                        <input matInput [matDatepicker]="picker1" formControlName="lodgmentDate"
                            placeholder="Enter Lodgment date">
                        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        @if(this.dsumanagerassessmentForm.controls["lodgmentDate"].invalid
                        && (this.dsumanagerassessmentForm.controls["lodgmentDate"].touched ||
                        this.dsumanagerassessmentForm.controls["lodgmentDate"].dirty)
                        ) {
                        <mat-error>
                            @if(this.dsumanagerassessmentForm.controls["lodgmentDate"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                    @if(isReadOnly() == false){
                    <button class="save-btn" type="button"
                        [disabled]="dsumanagerassessmentForm.controls['lodgmentDate'].invalid" (click)="saveLodgment()">
                        <span>Save Lodgment</span>
                    </button>
                    }
                </div>
                }
                <div class="row">
                    <div class="col-12">
                        <h5 class="field-title">Remarks</h5>
                    </div>
                    <mat-label class="field-label"></mat-label>
                    <mat-form-field class="text-field">

                        <textarea matInput formControlName="remarks" placeholder="Enter text"></textarea>
                    </mat-form-field>
                </div>

            </div>
            <h5 class="field-title">Acknowledgement</h5>
            <div class="dsu-container container-fluid">
                <div class="row align-items-start">
                    <mat-checkbox formControlName="declarationaccepted">I confirm that all required verification checks
                        have
                        been completed and supporting documents have been reviewed.</mat-checkbox>
                    @if(this.dsumanagerassessmentForm.controls["declarationaccepted"].invalid
                    && (this.dsumanagerassessmentForm.controls["declarationaccepted"].touched ||
                    this.dsumanagerassessmentForm.controls["declarationaccepted"].dirty)
                    ) {
                    <mat-error>
                        @if(this.dsumanagerassessmentForm.controls["declarationaccepted"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Name of DSU Manager
                        </label>

                        <mat-form-field class="w-100">
                            <input matInput formControlName="dsumanagername" placeholder="Enter DSU " readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Date
                        </label>

                        <mat-form-field class="w-100">
                            <input type="date" matInput formControlName="date" readonly />
                        </mat-form-field>
                    </div>
                </div>
                @if(this.errormessage != ''){
                <mat-error>

                    <span>{{errormessage}}</span>
                </mat-error>
                }
            </div>

            <!-- Other Attachments -->
            <div class="section-card other-attachments-card">
                <div class="section-header">
                    <mat-icon>attach_file</mat-icon>
                    <span>Other Attachments</span>
                </div>
                <div class="container-fluid">
                    <div class="row g-3">
                        @for(key of otherAttachmentKeys; track key){
                        <div class="col-md-6">
                            <div class="upload-container">
                                <div class="upload-box">
                                    <input type="file" [disabled]="isReadOnly()" [id]="key + 'fileName'"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        (change)="onOtherAttachmentFileChange($event, key)">
                                    <input type="text" [formControlName]="key + 'fileName'" hidden>

                                    <!-- Show filename OR placeholder -->
                                    @if(!this.dsumanagerassessmentForm.get(key + 'fileName')?.value){
                                    <span>
                                        Choose file
                                    </span>
                                    }
                                    @if(this.dsumanagerassessmentForm.get(key + 'fileName')?.value){
                                    <div class="attachment-row">
                                        <span class="file-name">
                                            {{ this.dsumanagerassessmentForm.get(key + 'fileName')?.value }}
                                        </span>
                                        @if(isReadOnly() === false){
                                        <button type="button" class="icon-btn delete-btn"
                                            (click)="removeOtherAttachmentFile(key)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        }
                                        <button type="button" class="icon-btn delete-btn"
                                            (click)="previewAttachment(key, key + 'fileName')">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                    }
                                </div>
                                @if(isReadOnly() === false){
                                @if(!$first){
                                @if(!this.dsumanagerassessmentForm.get(key + 'fileName')?.value){    
                                <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                                    matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                }
                                @if($last){
                                <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                                    matTooltip="Add another attachment" (click)="addOtherAttachment()">
                                    <mat-icon>add</mat-icon>
                                </button>
                                }
                                }
                            </div>
                            @if(this.dsumanagerassessmentForm.get(key + 'fileName')?.invalid
                            && (this.dsumanagerassessmentForm.get(key + 'fileName')?.touched ||
                            this.dsumanagerassessmentForm.get(key + 'fileName')?.dirty)
                            ) {
                            <mat-error>
                                @if(this.dsumanagerassessmentForm.get(key + 'fileName')?.errors?.['invalidType']){
                                <span>Only PDF, JPG, PNG files are allowed.</span>
                                }
                                @else if(this.dsumanagerassessmentForm.get(key + 'fileName')?.errors?.['maxSize']){
                                <span>File size must be less than or equal to 5MB.</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>

            @if(isReadOnly() == false){
            <div class="form-actions mt-4">
                <button class="save-btn" type="button" (click)="saveAndContinue()">
                    <span>Save</span>
                </button>
                <button class="save-btn" type="button" [disabled]="dsumanagerassessmentForm.invalid"
                    (click)="openConfirmDialog()">
                    <span>Submit</span>
                </button>
            </div>
            }
        </div>
    </div>
    @if (showPreview) {
    <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
        <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

            <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
                <div class="d-flex flex-column">
                    <span class="fw-bold fs-5">Document Preview</span>
                    <small class="text-muted">{{ currentFileName }}</small>
                </div>
                <div class="preview-header-actions">
                    @if (!isPdf) {
                    <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
                        <mat-icon>zoom_out</mat-icon>
                    </button>
                    <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
                    <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
                        <mat-icon>zoom_in</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="warn" (click)="closePreview()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Preview Content -->
            <div class="preview-content">
                @if (isPdf) {
                <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
                <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

                } @else {
                <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
                    [style.transform]="'scale(' + zoomLevel + ')'" />
                }
            </div>

        </div>
    </div>
    }
</div>